import { Dropdown } from 'react-bootstrap';
import React, { useState } from 'react';
import {message, notification} from 'antd';
import { getFile, paramBuilder, isCC } from '../../../../helpers/helpers';
import { SERVER } from '../../../../config/server.config';
import Modal from 'react-bootstrap/Modal';
import { routeToViewPracticeGameFilterForceScope } from '../../../../helpers/helpersts';
import ConfirmationModal from '../../../Shared/Modals/ConfirmationModal';
import store from '../../../../store';
import { BY_PERIOD, CONDENSED, FILTER_KEYS, GAME, VIEW, VIEW_LIVE } from '../../../../config/constants';
import './Export.scss';
import { Export as ExportProps, PerformanceRoutes } from '../types';
import { useRouter } from '../../../../helpers/customHooks';
import { useFiltersState, useUserState } from '../../../../store/hooks';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';

const Export = ({ teamId, isLivePractice, startTime, dataInProgress, isCustomLive } : ExportProps) => {

  const user = useUserState();
  const { params, eventType: type, forcedScopeForFilter: scopeForFilter } = useRouter<PerformanceRoutes>();
  const { id, teamId: teamOfInterest, tab, subTab, view } = params;
  const { [FILTER_KEYS.VIEW]: viewData = VIEW.types[0],
          [FILTER_KEYS.VIEW_LIVE]: viewLive = VIEW_LIVE.types[0] } = useFiltersState(scopeForFilter, FILTER_KEYS.VIEW, FILTER_KEYS.VIEW_LIVE);

  const [modal, setModal] = useState<React.ReactNode>(null);
  const{ download } = useFlagsState();
  const {  fileIsDownloading } = useFlagsDispatch();
    // Exports Notification
    const notificationKey = 'downloadFinished';
    const notificationDownload = (name:string) => {
      const args = {
        key: notificationKey,
        message: 'Download In Progress',
        description:
          `Your file ${name} is being processed.`,
        duration: 0,
        icon: <i className='mdi mdi-download' style={{color: '#0378bf'}}></i>
      };
      notification.open(args);
    };
    const notificationDownloadFinish = (name:string) => {
      const args = {
        key: notificationKey,
        message: 'Download Finished',
        description: `Your file ${name} has been downloaded successfully.`,
        duration: 4,
        icon: <i className='mdi mdi-check-underline' style={{color: '#0378bf'}}></i>
      };
      notification.open(args);
    };
    const notificationDownloadError = (name:string) => {
      const args = {
        key: notificationKey,
        message: `Error downloading file ${name}`,
        duration: 4,
        icon: <i className='mdi mdi-alert' style={{color: 'red'}}></i>
      };
      notification.open(args);
    };
    
  const exportCsv = async (filtered: boolean, gameView: string, isCustom?:boolean, isCustomLive?: boolean, totalsOnly?: boolean) => {
    fileIsDownloading(true);
    notificationDownload(`${id}.csv`);
    const path = store.getState().router.location.pathname;
    const scope = routeToViewPracticeGameFilterForceScope(path);
    let params = filtered ? store.getState().filters[scope] ? JSON.parse(JSON.stringify(store.getState().filters[scope])) : {} : {};
    params = { ...params, teamId };
    if (type === GAME) {
      params = {
        ...params,
        gameView: gameView ? gameView : null,
        teamOfInterest: gameView === 'plays' ? null : isCC(user) ? filtered ? teamOfInterest : null : teamOfInterest
      };
    }
    const localDate = new Date(startTime);
    params['tzOffset'] = -localDate.getTimezoneOffset();
    if (isLivePractice || dataInProgress) {
      params.isLive = 'true';
    }else if(isCustomLive){
      params.isLive = 'oldlive';
    }
    if(isCustom){
      params.customCsv = 'yes';
    }
    if(totalsOnly) params.totalsOnly = 'yes';
    const done = await getFile(SERVER.CSV_REPORT(id) + paramBuilder(params, (subTab === CONDENSED || (subTab === BY_PERIOD && view === CONDENSED))? true :false), `${id}.csv`);
    if (done) {
      fileIsDownloading(false);
      notificationDownloadFinish(`${id}.csv`);
    } else {
      fileIsDownloading(false);
      notificationDownloadError(`${id}.csv`);
    }
    setTimeout(() => setModal(null), 5000);
  };
  return (<>

    {modal}
    <Dropdown className="a-export">
      <Dropdown.Toggle id="dropdown-basic" className={`btn-blue`} disabled={download}>
        Export
      </Dropdown.Toggle>
      <Dropdown.Menu style={{width: '175px'}}>
        <Dropdown.Item onClick={() => exportCsv(false, type === GAME ? 'quarters' : '')}>
          <img src="/assets/images/zebra-logo.svg" alt="" height="15px" />
          {isLivePractice || dataInProgress ? 'Live Practice Export' : `Full ${type === GAME ? 'Game' : 'Practice'} Export`}
        </Dropdown.Item>
        {type === GAME && (
          <Dropdown.Item onClick={() => exportCsv(false, type === GAME ? 'plays' : '')}>Export Plays</Dropdown.Item>
        )}
        <Dropdown.Item onClick={() => exportCsv(true, type === GAME ? 'quarters' : '', 
        ((subTab === CONDENSED || (subTab === BY_PERIOD && view === CONDENSED))? viewLive.value === VIEW_LIVE.types[1].value : viewData.value === VIEW.types[10].value), isCustomLive)}>Export Filtered
          Data</Dropdown.Item>
          {!isLivePractice && (
            <Dropdown.Item onClick={() => exportCsv(false, type === GAME ? 'quarters' : '', false, false, true)}>
          Totals Only Export
        </Dropdown.Item>
          )}
      </Dropdown.Menu>
    </Dropdown>
  </>);
};

export default Export;